import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string
};

const defaultProps = {
    className: ''
};

function WarningIcon({ className }) {
    return <span className={`fa fa-exclamation-circle ${className}`} aria-hidden="true"/>;
}

WarningIcon.propTypes = propTypes;
WarningIcon.defaultProps = defaultProps;

export default WarningIcon;